import { BreadcrumbProps } from "@endya-conformite/ui-kit";
import React, { createContext, useContext } from "react";

type BreadcrumbContextType<T = string> = BreadcrumbProps<T> | null;

const BreadcrumbContext = createContext<BreadcrumbContextType>(null);

type BreadcrumbProviderProps<T = string> = {
  children: React.ReactNode;
  breadcrumb?: BreadcrumbProps<T>;
};

export function BreadcrumbProvider<T = string>({
  children,
  breadcrumb,
}: BreadcrumbProviderProps<T>) {
  return (
    <BreadcrumbContext.Provider
      value={(breadcrumb || null) as BreadcrumbContextType}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb<T = string>(): BreadcrumbContextType<T> {
  return useContext(BreadcrumbContext) as BreadcrumbContextType<T>;
}
